import { useLingui } from '@lingui/react'
import { type FunctionComponent } from 'react'

import './SellerShippingAddressBox.scss'
import type {
  CartControllerCartShippingDetailV2,
  CartControllerSellerGroupV2,
} from 'types/api/cart'
import Modal from 'views/components/molecules/Modal'

import DeliveryCostModalContent from './DeliveryCostModalContent'

type PropTypes = {
  sellerGroups: CartControllerSellerGroupV2[]
  shippingDetail: CartControllerCartShippingDetailV2[]
  currency: string
}

const DeliveryCostModal: FunctionComponent<PropTypes> = ({
  sellerGroups,
  shippingDetail,
  currency,
}: PropTypes) => {
  const { i18n } = useLingui()
  return (
    <Modal
      id={`sellerShippingAddressBoxModal`}
      title={i18n._('general.label.shippingCosts')}
      size="large"
      className="m-Modal__DeliveryCost"
    >
      <DeliveryCostModalContent
        sellerGroups={sellerGroups}
        shippingDetail={shippingDetail}
        currency={currency}
      />
    </Modal>
  )
}

export default DeliveryCostModal
